let prevAngle = 0

function normalizeAngle(current, target) {
  if (Math.abs(current - target) > 180) {
    if (current > 180) {
      return target + 360
    } else {
      return target - 360
    }
  }
  return target
}

export default function calculateDriverRotation(
  previousLocation: {lat: number; lng: number},
  newLocation: {lat: number; lng: number}
) {
  if (!previousLocation || !newLocation) {
    return 0
  }

  const y = newLocation.lat - previousLocation.lat
  const x = newLocation.lng - previousLocation.lng

  if (x === 0 && y === 0) {
    return prevAngle
  }

  // Calculate the angle between the previous and new location
  let angle = 90 - (Math.atan2(y, x) * 180) / Math.PI
  angle = normalizeAngle(prevAngle, angle)

  if (Math.abs(angle - prevAngle) < 10) {
    return prevAngle
  }

  prevAngle = angle
  return angle
}
